import type React from 'react';
import type { ReactElement, ReactNode } from 'react';

import BackButton from 'components/atoms/BackButton';
import Text from 'components/atoms/Text';
import * as Styled from './ScreenHeader.styled';

type ScreenHeaderProps = {
  screenTitle: string | ReactElement | ReactNode;
  description?: string | ReactElement | ReactNode;
  backTo?: string;
  onBack?: () => void;
  subHeader?: ReactNode;
  rightActions?: ReactNode;
  backCircle?: boolean;
  className?: string;
  fullWidth?: boolean;
};

const ScreenHeader: React.FC<ScreenHeaderProps> = ({
  screenTitle,
  description,
  backTo,
  onBack,
  rightActions,
  subHeader,
  backCircle = false,
  fullWidth = false,
  ...rest
}) => {
  return (
    <Styled.ScreenHeaderWrapper
      $backButton={!!backTo}
      $fullWidth={fullWidth}
      data-test-id="screen-header"
      id="screenHeader"
      {...rest}
    >
      {(!!backTo || !!onBack) && (
        <BackButton
          circle={backCircle}
          data-test-id="back-to-flow-table-button"
          to={backTo}
          onClick={onBack}
        />
      )}
      <Styled.Content>
        <Styled.HeadlineWrapper>
          <div className="flex items-center justify-between min-h-md1">
            <Styled.TitleWrapper>
              <Text
                as="h1"
                className="mr-xs2"
                data-test-id="screen-header-title"
                variant="headerLarge"
              >
                {screenTitle}
              </Text>
            </Styled.TitleWrapper>
            {rightActions}
          </div>
        </Styled.HeadlineWrapper>

        {subHeader}
        {description && <Styled.Description>{description}</Styled.Description>}
        <div />
      </Styled.Content>
    </Styled.ScreenHeaderWrapper>
  );
};

export default ScreenHeader;
